import { Checkbox } from 'antd';
import type { CheckboxProps } from 'antd';
import styled from 'styled-components';

export interface ScopeCheckboxProps extends CheckboxProps {
  /** 14×14px box — replaces legacy small-*-checkbox global class hacks. */
  compact?: boolean;
}

export const ScopeCheckbox = styled(Checkbox).withConfig({
  shouldForwardProp: (prop) => prop !== 'compact',
})<ScopeCheckboxProps>`
  font-family: var(--font-family) !important;
  font-size: var(--font-size-small) !important;
  font-weight: 400 !important;
  color: var(--color-text-muted) !important;

  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: var(--color-primary) !important;
    border-color: var(--color-primary) !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: var(--color-surface-raised, #ffffff) !important;
  }

  &:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: var(--color-primary) !important;
  }

  .ant-checkbox-checked::after {
    border-color: var(--color-primary) !important;
  }

  .ant-checkbox-inner {
    border-radius: var(--border-radius-base, 4px) !important;
  }

  ${(props) =>
    props.compact &&
    `
    .ant-checkbox-inner {
      width: 14px !important;
      height: 14px !important;
    }
    .ant-checkbox {
      min-width: 14px !important;
      min-height: 14px !important;
    }
  `}
`;
